import { LucideIcon } from 'lucide-react';

interface StatCardProps {
  label: string;
  value: string;
  sub: string;
  icon: LucideIcon;
  highlight?: boolean;
}

export function StatCard({ label, value, sub, icon: Icon, highlight }: StatCardProps) {
  return (
    <div className={`${highlight ? 'fitness-card-highlight' : 'fitness-card'} h-full group relative overflow-hidden`}>
      {/* Shimmer on highlight */}
      {highlight && <div className="shimmer absolute inset-0 pointer-events-none"></div>}
      
      {/* Subtle gradient overlay */}
      <div className={`absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 ${
        highlight 
          ? 'bg-gradient-to-br from-accent/5 to-transparent' 
          : 'bg-gradient-to-br from-secondary/50 to-transparent'
      }`}></div>
      
      <div className="relative z-10">
        <div className="flex justify-between items-start mb-4">
          <span className="fitness-label">{label}</span>
          <Icon className={`w-6 h-6 transition-all duration-300 group-hover:scale-110 ${highlight ? 'text-accent group-hover:drop-shadow-[0_0_8px_hsl(var(--accent)/0.5)]' : 'text-muted-foreground/50'}`} />
        </div>
        <div>
          <div className={`fitness-value ${highlight ? 'glow-text-accent' : ''}`}>{value}</div>
          <div className="text-xs font-bold text-muted-foreground mt-1 uppercase tracking-wider">{sub}</div>
        </div>
      </div>
    </div>
  );
}
